import { Routes, Route, Navigate } from 'react-router-dom';
import ReportsLayout from '../../components/reports/Layout';
import PerformanceManagement from './PerformanceManagement';
import CustomReportsPage from './CustomReportsPage';
import ReportViewerPage from './ReportViewerPage';
const ReportsRouter = () => {
  return (
    <Routes>
      <Route path="/" element={<ReportsLayout />}>
        {/* Default route redirects to On Demand reports (perform-spark) */}
        <Route index element={<Navigate to="/analytics/reports/perform-spark" replace />} />

        {/* Report Viewer - for viewing individual generated reports */}
        <Route path="view/:id" element={<ReportViewerPage />} />

        {/* Perform Spark is the main reports page */}
        <Route path="perform-spark" element={<PerformanceManagement />} />
        {/* Report Configuration Page (consolidated custom reports + generated reports) */}
        <Route path="configure" element={<CustomReportsPage />} />
        {/* Legacy route redirects for backwards compatibility */}
        <Route path="performance-management" element={<Navigate to="/analytics/reports/perform-spark" replace />} />
        <Route path="custom" element={<Navigate to="/analytics/reports/configure" replace />} />
        <Route path="overview" element={<Navigate to="/analytics/reports/configure" replace />} />
        {/* Redirect old report-builder path to new location */}
        <Route path="report-builder" element={<Navigate to="/analytics/report-builder" replace />} />
      </Route>
    </Routes>
  );
};

export default ReportsRouter;
